import ExcelJS from 'exceljs';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Box, Button, CircularProgress } from '@mui/material';
import { useEnumApi } from 'contexts/EnumApiContext';
import { getMaintenanceTasksExcelByQueryString } from './axios/maintenanceAxios';
import { useTranslation } from 'react-i18next';

const MaintenanceHistoryExcelDownload = ({excelParam}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    const title = t('message.common.btn.management.maintenance');
    const excelHeader = ["No.", t('message.common.subtitle.alertedAt'), t('message.common.subtitle.alertType'), t('message.common.subtitle.alertCategory')
        , t('message.common.subtitle.alertDetail'), t('message.common.subtitle.alert.checkedAt'), t('message.common.subtitle.alert.check.user')
        , t('message.common.subtitle.constantInspection.checkedAt'), t('message.common.subtitle.constantInspection.check.user')
        // , t('message.common.subtitle.subwayline'), t('message.common.subtitle.workingPart'), t('message.common.subtitle.station.name')
        , t('message.common.subtitle.equipment.level1'), t('message.common.subtitle.equipment.level2'), t('message.common.subtitle.equipment.level3'), t('message.common.subtitle.equipment.number')
        , t('message.common.subtitle.position'), t('message.common.subtitle.mfCpnyNm'), t('message.common.subtitle.madeYmd'), t('message.common.subtitle.provider.type')
        , t('message.common.subtitle.analysis.type'), t('message.common.subtitle.breakdown.maintenance.date'), t('message.common.subtitle.breakdown.maintenance.time')
        , t('message.common.subtitle.breakdown.maintenance.cause'), t('message.common.subtitle.work.start.date'), t('message.common.subtitle.work.start.time')
        , t('message.common.subtitle.used.equipment'), t('message.common.subtitle.work.end.date'), t('message.common.subtitle.work.end.time')
        , t('message.common.subtitle.actionType'), t('message.common.subtitle.worker'), t('message.common.subtitle.work.status'), t('message.common.subtitle.expense')
        , t('message.common.subtitle.work.detail'), t('message.common.subtitle.status.report.date'), t('message.common.subtitle.status.reporter')
        , t('message.common.subtitle.status.report.file'), t('message.common.subtitle.equipment.component'), t('message.common.subtitle.input.material')];
    const filename = title+"_"+Date.now()+".xlsx";
    const [excelDatas, setExcelDatas] = useState([]);

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Sheet1', {
      pageSetup: {
        paperSize: 9,
        orientation: 'landscape',
        horizontalCentered: true,
      },
    });
    ws.pageSetup.margins = {
      left: 0.7,
      right: 0.7,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3,
    };
  
    //ws.pageSetup.printArea = 'A1:F8';

    let excelData = [];
    excelData.push(
      {
        data: [title],
      },
      {
        data: [],
      }
    );

    // headerTitle
    excelData.push({data : excelHeader});

    // excelData
    excelDatas.forEach((item, index) => {
        excelData.push({data : item});
    });
  
    // console.log(excelData);

    excelData.forEach((item, index) => {
      ws.getRow(index + 1).values = [...item.data];
    });
  
    let dataStartIdx = 4;
    
    // 셀 병합
    let charCode;
    if ((excelHeader.length-1) < 26) {
        charCode = String.fromCharCode(65+(excelHeader.length-1));
    } else {
        let firstStr = String.fromCharCode(65+parseInt((excelHeader.length-1)/26)-1);
        let secondStr = String.fromCharCode(65+((excelHeader.length-1)%26));
        charCode = firstStr+secondStr;
    }
    ws.mergeCells('A1:'+charCode+'1');

    // 폰트 사이즈, 굵기, 색상 변경
    ws.getCell('A1').font = { size: 18, bold: true, color: { argb: '000000' } };
    // console.log(excelHeader)
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').font = { bold: true };
    });

    // 정렬
    ws.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').alignment = { horizontal: 'center', vertical: 'middle' };
    });
    
    excelDatas.forEach((item, index) => {
        excelHeader.forEach((item2, index2) => {
            let charCode;
            if (index2 < 26) {
                charCode = String.fromCharCode(65+index2);
            } else {
                let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                let secondStr = String.fromCharCode(65+(index2%26));
                charCode = firstStr+secondStr;
            }
            ws.getCell(charCode+(index+dataStartIdx)).alignment = { horizontal: 'center', vertical: 'middle' };
        });
    });

    // 색 칠하기
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e0e0e0' },
        };
    });
    
    
    // 테두리
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').border = {
            top: { style: 'medium', color: { argb: '000000' } },
        };
    });
    
    excelDatas.forEach((item, index) => {
        
        excelHeader && excelHeader.forEach((item2, index2) => {
                let charCode;
                if (index2 < 26) {
                    charCode = String.fromCharCode(65+index2);
                } else {
                    let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                    let secondStr = String.fromCharCode(65+(index2%26));
                    charCode = firstStr+secondStr;
                }
                ws.getCell(charCode+(index+dataStartIdx)).border = {
                    top: { style: 'thin', color: { argb: '000000' } },
                };
                if (index === (excelDatas.length-1)) {
                    let charCode;
                    if (index2 < 26) {
                        charCode = String.fromCharCode(65+index2);
                    } else {
                        let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                        let secondStr = String.fromCharCode(65+(index2%26));
                        charCode = firstStr+secondStr;
                    }
                    ws.getCell(charCode+(index+dataStartIdx)).border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                    };
                }
            });
    });

    // 가로 길이
    const col = [];
    for (let i = 0; i < excelHeader.length; i++) {
        col.push({
            key: 'data',
            width: 15,
        });
    }
    ws.columns = col;
  
    // 세로 길이
    for (let i = 1; i <= excelData.length; i++) {
      let row = ws.getRow(i);
      row.height = 22;
    }
  
    // 줄 바꿈
    // ws.getCell('A3').alignment = { wrapText: true };
    const [finish, setFinish] = useState('standby');

    useEffect(() => {
        // console.log(finish)
        // console.log(excelDatas)
        if (finish === 'end') {
            setFinish('standby')
            wb.xlsx.writeBuffer().then((b) => {
                let a = new Blob([b]);
                let url = window.URL.createObjectURL(a);
        
                let elem = document.createElement('a');
                elem.href = url;
                elem.download = filename;
                elem.click();
                elem.remove();
            });
        }
    }, [finish])

    const download = () => {
        setFinish('progress')
        Promise.all([
            getMaintenanceTasksExcelByQueryString("?"+excelParam).then((data)=>{
                if (data != null) {
                //  console.log(data);
                  if(data._embedded) {
                    let list = data._embedded.maintenanceTasks;
                    let excelDatas = [];
                    let excelData = [];
                    list && list.forEach(function (column, a) {
                        let alertDtl = column?.equipmentAlert?.alertDtl;
                      excelData = [
                        (data.page.totalElements-a),
                        ((column?.equipmentAlert?.latestAlertedAt && dayjs(column?.equipmentAlert?.latestAlertedAt).format("YYYY-MM-DD HH:mm")) || ''),
                        ((getEnumValueByEnumNameAndCode("AlertType", column?.equipmentAlert?.alertType)?.[0]?.title) || ''),
                        ((getEnumValueByEnumNameAndCode("AlertCategory", column?.equipmentAlert?.alertCategory)?.[0]?.title) || ''),
                        ((alertDtl) || ''),
                        ((column?.equipmentAlert?.chkedAt && dayjs(column?.equipmentAlert?.chkedAt).format("YYYY-MM-DD HH:mm")) || ''),
                        ((column?.equipmentAlert?.chkUser) || ''),
                        ((column?.equipmentAlert?.fieldChkedAt && dayjs(column?.fieldChkedAt?.alertedAt).format("YYYY-MM-DD HH:mm")) || ''),
                        ((column?.equipmentAlert?.fieldChkUser) || ''),
                        // ((getEnumValueByEnumNameAndCode("SubwayLine", column?.equipment?.station?.workingPart?.subwayLine)?.[0]?.title) || ''),
                        // ((column?.equipment?.station?.workingPart?.name) || ''),
                        // ((column?.equipment?.station?.name) || ''),
                        ((column?.equipment?.equipmentCtgr?.parent?.parent?.name) || ''),
                        ((column?.equipment?.equipmentCtgr?.parent?.name) || ''),
                        ((column?.equipment?.name) || ''),
                        ((column?.equipment?.equipmentNo) || ''),
                        ((column?.equipment?.location) || ''),
                        ((column?.equipment?.mfCpnyNm) || ''),
                        ((column?.equipment?.madeYmd) || ''),
                        ((getEnumValueByEnumNameAndCode("MaintenanceProviderType", column?.mntSpType)?.[0]?.title) || ''),
                        ((getEnumValueByEnumNameAndCode("MaintenanceRecordType", column?.recordType)?.[0]?.title) || ''),
                        ((column?.troubledAt && dayjs(column?.troubledAt).format("YYYY-MM-DD")) || ''),
                        ((column?.troubledAt && dayjs(column?.troubledAt).format("HH:mm:ss")) || ''),
                        ((column?.troubleReason) || ''),
                        ((column?.workingBgnAt && dayjs(column?.workingBgnAt).format("YYYY-MM-DD")) || ''),
                        ((column?.workingBgnAt && dayjs(column?.workingBgnAt).format("HH:mm:ss")) || ''),
                        ((column?.usedMethod) || ''),
                        ((column?.workingEndAt && dayjs(column?.workingEndAt).format("YYYY-MM-DD")) || ''),
                        ((column?.workingEndAt && dayjs(column?.workingEndAt).format("HH:mm:ss")) || ''),
                        ((getEnumValueByEnumNameAndCode("MaintenanceType", column?.type)?.[0]?.title) || ''),
                        ((column?.worker) || ''),
                        ((getEnumValueByEnumNameAndCode("MaintenanceStatus", column?.status)?.[0]?.title) || ''),
                        ((column?.cost?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')) || ''),
                        ((column?.remark) || ''),
                        ((column?.statusReport?.reportYmd) || ''),
                        ((column?.statusReport?.reportUser) || ''),
                        ((column?.statusReport?.reportFiles) ? 'O' : 'X'),
                        ((column?.equipmentCtgr?.name) || '') + ' ' + ((column?.position) || '')
                      ];
                      if (column?.equipmentParts?.length > 0) {
                        (column?.equipmentParts).map((part)=>{
                            excelData.push(part.masterEquipmentPart.name)
                        })
                      }
                    //   console.log(excelData);
                      excelDatas.push(excelData);
                    });
                    // console.log(excelDatas)
                    setExcelDatas(excelDatas);
                  } else {
                    setExcelDatas([]);
                  }
                } else {
                  setExcelDatas([]);
                }
                setFinish('end')
            })
        ]).then(() => {
            
        });
    }

    return (
        (finish === 'standby' || finish === 'end') ?
        <Button variant="contained" color="success" onClick={download} style={{margin:"3px"}}>
          {t('message.common.btn.excel.download')}
        </Button>
        :
        <div className='no-print-page' style={{color:"#000"}}>
            <Box sx={{ display: 'flex', color:"#000" }}>
                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
            </Box>
        </div>
    )
};

export default MaintenanceHistoryExcelDownload;